"use client";

import { useTechnologyData } from "../../../hooks/useTechnologyData";
import ProductCard from "@/components/entities/product-card";
import S from "./index.module.scss";

const ProductsList = () => {
  const { detailTechnology, isLoading } = useTechnologyData();

  if (!detailTechnology || !detailTechnology.products?.length || isLoading) return null;

  return (
    <div className={S.wrapper}>
      <h2 className={S.title}>{detailTechnology.technology?.title}</h2>
      <div className={S.productsList}>
        {detailTechnology.products?.map(item => (
          <ProductCard key={item.id} product={item} />
        ))}
      </div>
    </div>
  );
};

export default ProductsList;
